import { isObject } from 'lodash';

export default {
  created() {
    if (!this.eventBus) {
      return;
    }
    const { microEvents } = this.$options;
    if (microEvents && isObject(microEvents)) {
      Object.keys(microEvents).forEach(key => {
        const fn = microEvents[key];
        if (typeof fn !== 'function') {
          return;
        }
        const bindFn = fn.bind(this);
        this.eventBus.$on(key, bindFn);
        fn.__bindFn = bindFn;
      });
    }
  },
  beforeDestroy() {
    const { microEvents } = this.$options;
    if (microEvents && isObject(microEvents)) {
      Object.keys(microEvents).forEach(key => {
        const fn = microEvents[key];
        if (typeof fn.__bindFn !== 'function') {
          return;
        }
        this.eventBus.$off(key, fn.__bindFn);
      });
    }
  }
};
